import React, { Component } from 'react'

class LargeLoader extends Component {
  componentWillMount = () => {
    if (window.location.href.includes('login=success')) {
      window.close()
    }
    
  }
  render() {
    return <div className="large-loader">&nbsp;</div>
  }
}

export default LargeLoader



// WEBPACK FOOTER //
// ./src/loader.js